import React from 'react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Controller } from 'react-hook-form';
import FormHelperText from '@mui/material/FormHelperText';

const EpisodeDropdown = (props) => {
  const {
    name,
    control,
    label,
    options,
    defaultId,
    errors,
    helperText,
    disabled,
    isIncarcerationInstitution,
    isReferralSource,
    isParoleAgent,
  } = props;

  const generateSingleOptions = () => {
    return options?.map((item, index) => {
      return (
        <MenuItem
          key={index}
          value={
            isIncarcerationInstitution
              ? item.orgId
              : isReferralSource
              ? item.orgId
              : isParoleAgent
              ? item.cntId
              : item.id
          }
        >
          {item.value}
          {isIncarcerationInstitution && item.orgKey}
          {isReferralSource && item.referralSource}
          {isParoleAgent && item.paroleAgent}
        </MenuItem>
      );
    });
  };

  return (
    <FormControl style={{ display: 'flex', marginBottom: '20px' }}>
      <InputLabel>{label}</InputLabel>
      <Controller
        render={({ field: { onChange, onBlur, value } }) => (
          <Select
            defaultValue={defaultId}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            error={errors}
            disabled={disabled}
          >
            {generateSingleOptions()}
          </Select>
        )}
        control={control}
        name={name}
      />
      <FormHelperText style={{ color: '#ff4d4f' }}>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default EpisodeDropdown;
